import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../../core/has.js";
import e from "../../../../core/Logger.js";
import { objectEqual as t } from "../snappingUtils.js";
import { SnappingHint as r } from "./SnappingHint.js";
e.getLogger("esri.views.interactive.snapping.hints.RightAngleSnappingHint");

var i = /*#__PURE__*/function (_r) {
  _inherits(i, _r);

  var _super = _createSuper(i);

  function i(e, t, r) {
    var _this;

    _classCallCheck(this, i);

    _this = _super.call(this), _this.previousVertex = e, _this.centerVertex = t, _this.nextVertex = r;
    return _this;
  }

  _createClass(i, [{
    key: "equals",
    value: function equals(e) {
      return e instanceof i && t(this.previousVertex, e.previousVertex) && t(this.centerVertex, e.centerVertex) && t(this.nextVertex, e.nextVertex);
    }
  }]);

  return i;
}(r);

export { i as RightAngleSnappingHint };